<template>
  <div :class="alertClass" class="w-full flex justify-start">
    <p class="text-xs lg:text-sm font-medium" :class="textAlign">
      {{ $t('backoffice.orders.orderAlert') }} {{ orderedQty }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    orderedQty: {
      type: Number,
      default: 0,
    },
    overlapping: {
      type: Boolean,
      default: false,
    },
    textAlign: {
      type: String,
      default: 'text-left',
    },
  },
  computed: {
    alertClass() {
      return this.overlapping ? 'bg-red-700/70 border border-red-700 py-1 px-2 rounded text-white' : 'text-red-700';
    },
  },
};
</script>
